import Cookies from 'js-cookie'

export function isLogin() {
  return getToken() ? true : false
}

const TOKEN_KEY = 'token'

export function getToken() {
  return Cookies.get(TOKEN_KEY)
}

export function setToken(token) {
  Cookies.set(TOKEN_KEY, token)
}

export function removeToken() {
  Cookies.remove(TOKEN_KEY)
}

const MOBILE_KEY = 'mobile'

export function getMobile() {
  return Cookies.get(MOBILE_KEY)
}

export function setMobile(mobile) {
  Cookies.set(MOBILE_KEY, mobile)
}

export function removeMobile() {
  Cookies.remove(MOBILE_KEY)
}

const ACCOUNT_KEY = 'userName'

export function getAccount() {
  return Cookies.get(ACCOUNT_KEY)
}

export function setAccount(account) {
  Cookies.set(ACCOUNT_KEY, account)
}

export function removeAccount() {
  Cookies.remove(ACCOUNT_KEY)
}


const AVA_KEY = 'avatar'

export function getAva() {
  return Cookies.get(AVA_KEY)
}

export function setAva(avatar) {
  Cookies.set(AVA_KEY, avatar)
}

export function removeAva() {
  Cookies.remove(AVA_KEY)
}

const STATE_KEY = 'state'

export function getState() {
  return Cookies.get(STATE_KEY)
}

export function setState(state) {
  Cookies.set(STATE_KEY, state)
}

export function removeState() {
  Cookies.remove(STATE_KEY)
}

export function removeUserInfo() {
  removeToken()
  removeAccount()
  removeMobile()
  removeAva()
  removeState()
}


